var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalmart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 117.874,
    height: 22.177,
    viewBox: "0 0 117.874 22.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18442",
    "data-name": "Rectangle 18442",
    width: 117.874,
    height: 22.177,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47762",
    "data-name": "Group 47762",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46813",
    "data-name": "Path 46813",
    d: "M23.189,0,20.356,14.2,17.175,0H11.653L8.472,14.2,5.639,0H0L4.6,21.685h6.564l3.209-14.4,3.21,14.4H24L28.567,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47761",
    "data-name": "Group 47761",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47760",
    "data-name": "Group 47760",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46814",
    "data-name": "Path 46814",
    d: "M428.482,60.932c-3.5,0-5.956,1.185-6.853,2.024v4.626a9.478,9.478,0,0,1,6.13-2.284c1.793,0,2.458.492,2.458,1.5,0,.867-.925,1.214-3.5,1.764-3.9.81-6.159,2.226-6.159,5.609a4.653,4.653,0,0,0,5.031,4.944,5.023,5.023,0,0,0,4.8-2.712v2.22h5.378V67.987c0-4.886-2.544-7.055-7.286-7.055m-.752,14.688a1.779,1.779,0,0,1-1.966-1.85c0-1.388,1.1-1.937,2.487-2.429a6.427,6.427,0,0,0,1.937-.983v2.4c0,1.821-.954,2.862-2.458,2.862",
    transform: "translate(-393.019 -56.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18441",
    "data-name": "Rectangle 18441",
    width: 5.58,
    height: 21.686,
    transform: "translate(44.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46815",
    "data-name": "Path 46815",
    d: "M819.87,61.815a5.666,5.666,0,0,0-5.372,3.794,4.394,4.394,0,0,0-4.4-3.794,5.316,5.316,0,0,0-5.118,3.621V62.307h-5.494V79.453h5.58V69.94c0-2.342.781-3.672,2.458-3.672,1.359,0,1.822.925,1.822,2.371V79.453h5.58V69.94c0-2.342.781-3.672,2.458-3.672,1.359,0,1.822.925,1.822,2.371V79.453h5.58V67.858c0-3.614-1.706-6.043-4.916-6.043",
    transform: "translate(-747.131 -57.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46816",
    "data-name": "Path 46816",
    d: "M1212.292,60.932c-3.5,0-5.956,1.185-6.853,2.024v4.626a9.477,9.477,0,0,1,6.13-2.284c1.792,0,2.458.492,2.458,1.5,0,.867-.925,1.214-3.5,1.764-3.9.81-6.159,2.226-6.159,5.609a4.653,4.653,0,0,0,5.031,4.944,5.023,5.023,0,0,0,4.8-2.712v2.22h5.378V67.987c0-4.886-2.544-7.055-7.286-7.055m-.752,14.688a1.779,1.779,0,0,1-1.966-1.85c0-1.388,1.1-1.937,2.487-2.429a6.428,6.428,0,0,0,1.937-.983v2.4c0,1.821-.954,2.862-2.458,2.862",
    transform: "translate(-1125.5 -56.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46817",
    "data-name": "Path 46817",
    d: "M1471.224,72.4V67.556h-5.464V84.7h5.58V77.416c0-3.354,2.082-4.25,4.077-4.25a6.549,6.549,0,0,1,1.59.173v-5.9c-3.14-.152-5.047,1.854-5.783,4.96",
    transform: "translate(-1369.773 -63.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46818",
    "data-name": "Path 46818",
    d: "M1669.612,26.206V21.869h-3.557V18.544h-5.58V33.29c0,4.135,2.342,6.072,6.072,6.072a5.876,5.876,0,0,0,3.065-.607V34.447a2.594,2.594,0,0,1-1.5.4c-1.243.029-2.053-.52-2.053-2.342v-6.3Z",
    transform: "translate(-1551.738 -17.33)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmart);
export default __webpack_public_path__ + "static/media/Walmart.e0fe52dd5ab1ce37f416a62d7f6cd751.svg";
export { ForwardRef as ReactComponent };